import axios from 'axios'
import Cookies from 'universal-cookie'
import { CleanJsonData, ClearCookies } from '../Utilities/Utilities.js'

//const
const data = {
    user: { success: false, message: null, client: null },
    listUser: { success: false, message: null, list: [] },
    listRol: { success: false, message: null, list: [] },
    listRolWithModules: [],
    availableModules: [],
}

const LOG_IN_USER = 'LOG_IN_USER'
const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS'
const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
const GET_ROL_LIST_SUCCESS = 'GET_ROL_LIST_SUCCESS'
const GET_ROLES_WITH_MODULES = 'GET_ROLES_WITH_MODULES'
const GET_AVAILABLE_MODULES = 'GET_AVAILABLE_MODULES'

// reducer
export default function userReducer(state = data, action) {
    switch (action.type) {
        case LOG_IN_USER:
            return { ...state, user: action.payload }            
        case GET_USER_LIST_SUCCESS:
            return { ...state, listUser: action.payload }
        case CREATE_USER_SUCCESS:
            return { 
                ...state, 
                listUser: { 
                    ...state.listUser, 
                    list: [...state.listUser.list, action.payload] 
                }
            };
        case UPDATE_USER_SUCCESS:
            const { id, data: newData } = action.payload;

            // Actualizar usuario si existe, de lo contrario añadirlo
            const updatedUsers = state.listUser.list.map(user =>
                user.id === id ? { ...user, ...newData } : user
            );

            const userExists = state.listUser.list.some(user => user.id === id);
            const finalUsers = userExists
                ? updatedUsers
                : [...updatedUsers, { id, ...newData }];

            return {
                ...state,
                listUser: { ...state.listUser, list: finalUsers }
            };
        case DELETE_USER_SUCCESS:
            return { ...state }
        case GET_ROL_LIST_SUCCESS:
            return { ...state, listRol: action.payload }
        case GET_ROLES_WITH_MODULES:
            return { ...state, listRolWithModules: action.payload }
        case GET_AVAILABLE_MODULES:
            return { ...state, availableModules: action.payload }
        default:
            return state
    }
}


export const LoginUser = (DATA, causa) => async (dispatch, getState) => {
    const cookies = new Cookies();
    ClearCookies(cookies)
    DATA = CleanJsonData(DATA);

    dispatch({
        type: LOG_IN_USER,
        payload: { success: false, message: window.messagesAxios.loginStart, user: null }
    })

    try {
        const RES = await axios.post(window.API_URL+'/Login', DATA)

        if (RES.status === 200) {
            const data = RES.data
            
            for (let key in data)
                if (data.hasOwnProperty(key))
                    cookies.set(key, data[key], { path: "/" })

            dispatch({
                type: LOG_IN_USER,
                payload: { success: true, message: window.messagesAxios.loginSuccess, user: data }
            })
        }
        else {
            dispatch({
                type: LOG_IN_USER,
                payload: { success: false, message: window.messagesAxios.loginError, user: null }
            })
        }
    } catch (error) {
        if (error?.response?.status === 404) {
            dispatch({
                type: LOG_IN_USER,
                payload: { success: false, message: error?.response?.data, user: null }
            })
        }
        else {
            dispatch({
                type: LOG_IN_USER,
                payload: { success: false, message: window.messagesAxios.loginError, user: null }
            })
        }
    }
}

export const LogoutUser = () => async (dispatch, getState) => {
    const cookies = new Cookies();
    ClearCookies(cookies)
    dispatch({
        type: LOG_IN_USER,
        payload: { success: false, message: window.messagesAxios.logout, user: null }
    })
}



export const GetListUsers = (DATA) => async (dispatch, getState) => {

    const cookies = new Cookies()
    DATA = CleanJsonData(DATA)

    dispatch({
        type: GET_USER_LIST_SUCCESS,
        payload: { success: false, message: window.messagesAxios.getListUsersStart, list: [] }
    })

    try { // nombre rut telefono direccion
        const RES = await axios.post(window.API_URL+"/GetAllUser", null,{headers: {'Authorization': `Bearer ${cookies.get('token')}`}})
        //console.log(RES)
        if(RES.status === 200 ){
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersSuccess, list: RES.data }
            })
        }
        else {
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, list: [] }
            })
        }

    } catch (error) {
        if (error?.response?.status === 404) {
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: error?.response?.data, list: [] }
            })
        }
        else {
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, user: null }
            })
        }
    }
}

export const CreateUser = (DATA) => async (dispatch, getState) => {

    const cookies = new Cookies()
    DATA = CleanJsonData(DATA)

    dispatch({
        type: CREATE_USER_SUCCESS,
        payload: { success: false, message: window.messagesAxios.getListUsersStart, list: [] }
    })

    try { // nombre rut telefono direccion
        const RES = await axios.post(window.API_URL+"/CreateUser", DATA,{headers: {'Authorization': `Bearer ${cookies.get('token')}`}})
        //console.log(RES)
        if(RES.status === 200 ){
            dispatch({
                type: CREATE_USER_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersSuccess, list: RES.data }
            })
        }
        else {
            dispatch({
                type: CREATE_USER_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, list: [] }
            })
        }

    } catch (error) {
        if (error?.response?.status === 404) {
            dispatch({
                type: CREATE_USER_SUCCESS,
                payload: { success: false, message: error?.response?.data, list: [] }
            })
        }
        else {
            dispatch({
                type: CREATE_USER_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, user: null }
            })
        }
    }
}

export const UpdateUser = (DATA) => async (dispatch, getState) => {

    const cookies = new Cookies()
    DATA = CleanJsonData(DATA)

    dispatch({
        type: UPDATE_USER_SUCCESS,
        payload: { success: false, message: window.messagesAxios.getListUsersStart, list: [] }
    })

    try { // nombre rut telefono direccion
        const RES = await axios.put(window.API_URL+"/UpdateUser", DATA,{headers: {'Authorization': `Bearer ${cookies.get('token')}`}})
        //console.log(RES)
        if(RES.status === 200 ){
            dispatch({
                type: UPDATE_USER_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersSuccess, list: RES.data }
            })
        }
        else {
            dispatch({
                type: UPDATE_USER_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, list: [] }
            })
        }

    } catch (error) {
        if (error?.response?.status === 404) {
            dispatch({
                type: UPDATE_USER_SUCCESS,
                payload: { success: false, message: error?.response?.data, list: [] }
            })
        }
        else {
            dispatch({
                type: UPDATE_USER_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, user: null }
            })
        }
    }
}

export const DeleteUser = (userId) => async (dispatch) => {
    const cookies = new Cookies()
    try {
        const RES = await axios.delete(window.API_URL + '/DeleteUser', {
            params: { oldUserId: userId },
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        if (RES.status === 200) {
            dispatch({ type: DELETE_USER_SUCCESS, payload: {} })
        }
    } catch (error) {
        console.error('Error al eliminar usuario', error)
    }
}

export const GetUserRoles = (DATA) => async (dispatch, getState) => {

    const cookies = new Cookies()
    DATA = CleanJsonData(DATA)

    dispatch({
        type: GET_ROL_LIST_SUCCESS,
        payload: { success: false, message: window.messagesAxios.getListUsersStart, list: [] }
    })

    try {
        const RES = await axios.post(window.API_URL+"/GetAllRoles", null,{headers: {'Authorization': `Bearer ${cookies.get('token')}`}})
        if(RES.status === 200 ){
            dispatch({
                type: GET_ROL_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersSuccess, list: RES.data }
            })
        }
        else {
            dispatch({
                type: GET_ROL_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, list: [] }
            })
        }

    } catch (error) {
        if (error?.response?.status === 404) {
            dispatch({
                type: GET_ROL_LIST_SUCCESS,
                payload: { success: false, message: error?.response?.data, list: [] }
            })
        }
        else {
            dispatch({
                type: GET_ROL_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, user: null }
            })
        }
    }
}

export const GetRolesWithModules = () => async (dispatch) => {
    const cookies = new Cookies()
    try {
        const RES = await axios.get(window.API_URL + '/GetRolesWithModules', {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        if (RES.status === 200) {
            dispatch({ type: GET_ROLES_WITH_MODULES, payload: RES.data })
        }
    } catch (error) {
        console.error('Error fetching roles with modules', error)
    }
}

export const CreateRole = (data) => async (dispatch) => {
    const cookies = new Cookies()
    try {
        const RES = await axios.post(window.API_URL + '/CreateRole', data, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        if (RES.status === 200) {
            dispatch(GetRolesWithModules())
        }
        return RES.data
    } catch (error) {
        console.error('Error creating role', error)
        throw error
    }
}

export const UpdateRoleModules = (id, data) => async (dispatch) => {
    const cookies = new Cookies()
    try {
        const RES = await axios.put(window.API_URL + `/UpdateRoleModules/${id}`, data, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        if (RES.status === 200) {
            dispatch(GetRolesWithModules())
        }
        return RES.data
    } catch (error) {
        console.error('Error updating role', error)
        throw error
    }
}

export const DeleteRole = (id) => async (dispatch) => {
    const cookies = new Cookies()
    try {
        const RES = await axios.delete(window.API_URL + `/DeleteRoleById/${id}`, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        if (RES.status === 200) {
            dispatch(GetRolesWithModules())
        }
        return RES.data
    } catch (error) {
        console.error('Error deleting role', error)
        throw error
    }
}

export const GetAvailableModules = () => async (dispatch) => {
    const cookies = new Cookies()
    try {
        const RES = await axios.get(window.API_URL + '/GetAvailableModules', {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        if (RES.status === 200) {
            dispatch({ type: GET_AVAILABLE_MODULES, payload: RES.data })
        }
    } catch (error) {
        console.error('Error fetching modules', error)
    }
}

export const GetUserBusinessLines = (userId) => async () => {
    const cookies = new Cookies()
    try {
        const RES = await axios.get(window.API_URL + `/GetUserBusinessLines?userId=${userId}`, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        return RES.status === 200 ? RES.data : []
    } catch (error) {
        console.error('Error fetching user business lines', error)
        return []
    }
}

export const SetUserBusinessLines = (userId, ids) => async () => {
    const cookies = new Cookies()
    try {
        const RES = await axios.put(window.API_URL + `/SetUserBusinessLines?userId=${userId}`, ids, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        })
        return RES.status === 200
    } catch (error) {
        console.error('Error setting user business lines', error)
        return false
    }
}
